import { render, staticRenderFns } from "./AddToWatchListButton.vue?vue&type=template&id=0b1ecd30"
import script from "./AddToWatchListButton.vue?vue&type=script&lang=js"
export * from "./AddToWatchListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports